import React, { useState } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { Tooltip } from "reactstrap";
import PriceFormat from "components/PriceFormat";
import { Link } from "react-router-dom";

const Purchase = ({ purchase, accessCourseLink, accessFreeCourseLink }) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggle = () => setTooltipOpen(!tooltipOpen);

  return (
    <div className="purchaseHistory__table">
      <div className="purchaseHistory__head__container">
        <div className="purchaseHistory__header__container">
          <div className="purchaseHistory__headings__container">
            <p className="purchaseHistory__orderId">
              ORDER ID:
              {"  "}
              {purchase.orderNumber}
            </p>
            <p className="purchaseHistory__purchaseDate">
              PURCHASE DATE:
              {"  "}
              {moment(purchase.orderDate).format("M/D/YYYY")}
            </p>
            <p className="purchaseHistory__orderTotal">
              ORDER TOTAL:
              {"  "}
              <PriceFormat value={purchase.total} />
            </p>
            {purchase.expired && (
              <p className="purchaseHistory__expiredCourse">
                EXPIRED
                {"  "}
                {`${moment(purchase.expiredDate).format("M/D/YYYY")}`}
                <button
                  className="purchaseHistory__tooltip__hover"
                  type="button"
                  id={`tooltip-${purchase.orderNumber}`}
                >
                  i
                </button>
                <Tooltip
                  placement="left"
                  isOpen={tooltipOpen}
                  target={`tooltip-${purchase.orderNumber}`}
                  toggle={toggle}
                >
                  Individual license access expires after 1 year
                </Tooltip>
              </p>
            )}
          </div>
          <div className="purchaseHistory__buttons__container">
            {!purchase.expired && (
              <div className="purchaseHistory__accessCourse">
                <a
                  href={
                    purchase.total < 1 ? accessFreeCourseLink : accessCourseLink
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Access Course(s)
                </a>
              </div>
            )}
            <div className="purchaseHistory__receipt">
              <Link
                target="_blank"
                to={{
                  pathname: `/orders/${purchase.omsOrderId}`,
                  state: {
                    orderId: purchase.omsOrderId
                  }
                }}
              >
                View&nbsp;Receipt
              </Link>
            </div>
          </div>
        </div>
      </div>
      {purchase.orderLineItems.map(item => (
        <p key={item.sku} className="purchaseHistory__body">
          {item.productName}
        </p>
      ))}
    </div>
  );
};

Purchase.propTypes = {
  accessCourseLink: PropTypes.string.isRequired,
  accessFreeCourseLink: PropTypes.string.isRequired,
  purchase: PropTypes.shape({
    omsOrderId: PropTypes.number,
    orderNumber: PropTypes.string,
    orderDate: PropTypes.string,
    total: PropTypes.number,
    expired: PropTypes.bool,
    expiredDate: PropTypes.string,
    orderLineItems: PropTypes.array
  }).isRequired
};

export default Purchase;
